import React from 'react';
import Heading from './Heading';
import Guide from './Guide';

class Instructions extends React.Component {
  render() {
    return (
      <div>
        <Heading />
        <Guide />
      </div>
    );
  }
}

export default Instructions;
